<template>
  <div>
    <div style="padding: 10px">
      <div v-if="storeGuid">
        <x-table
          ref="list"
          listApi="biz.warehouse.demand.info.listByStorehouse"
          paginationLayout="total, sizes, prev, next, jumper"
          actionFixed="right"
          emptyLabel="暂无要货单信息"
          :fieldList="fieldList"
          :actionList="actionList"
          :defaultParams="defaultParams"
          :actionWidth="180"
        >
          <template slot="row-info" slot-scope="scope">
            <warehouse-demand-info
              :showCount="false"
              :demandInfo="scope.row"
              @purchaseListClick="purchaseListClick"
              @replenishListClick="replenishListClick"
              :showCost="true"
            >
            </warehouse-demand-info>
          </template>
        </x-table>
      </div>
      <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
    </div>
  </div>
</template>

<script>
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';
import warehouseDemandInfo from '../../../../components/business/warehouseDemandInfo.vue';
import demandReplenish from './_replenish.vue';
import demandDetail from './_detail_storehouse.vue';

export default {
  components: {
    customerStoreSelect,
    warehouseDemandInfo,
  },
  props: {
    storeGuid: {
      type: String,
    },
    queryModel: {
      type: Object
    }
  },
  computed: {
    defaultParams() {
      return Object.assign({
        optCancel: "0",
        storeGuid: this.storeGuid,
      }, this.queryModel || {});
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    openDetailPage(row, tabName) {
      this.$drawer.openDrawer({
        title: '要货单详细信息',
        refresh: this.refresh,
        component: demandDetail,
        params: {
          guid: row.guid,
          storehouseGuid: row.storehouseGuid,
          tabName: tabName,
        },
      });
    },
    purchaseListClick(row) {
      this.openDetailPage(row, 'demand-purchase');
    },
    replenishListClick(row) {
      this.openDetailPage(row, 'demand-replenish');
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "要货单信息",
          minWidth: '280',
          slot: "info",
        },
      ],
      actionList: [
        {
          label: '详情',
          linkType: 'primary',
          click: (row, tag, refresh) => {
            this.openDetailPage(row);
          },
        },
        {
          label: '供货报价',
          linkType: 'primary',
          disabled: (row) => {
            return !(row.optCancel == 0
              && row.optPurchase != 2
              && row.optReplenish != 2)
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '创建供货报价单',
              refresh: this.refresh,
              component: demandReplenish,
              params: {
                storeGuid: row.storeGuid,
                storehouseGuid: row.storehouseGuid,
                demandGuid: row.guid,
              },
            });
          },
        },
      ],
    };
  },
};
</script>